import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
} from "./utils/utils"
import { unique } from "utils/utils"

// CONSTANTS
export const STACKS_FETCHED = "STACKS_FETCHED"
export const STACK_CREATED = "STACK_CREATED"
export const STACK_UPDATED = "STACK_UPDATED"
export const STACK_REMOVED = "STACK_REMOVED"
export const STACK_SELECTED = "STACK_SELECTED"

// API
class StackApi extends StackerAPI {
    path = "stacks/"
}
const stackApi = new StackApi()

class StackActions extends StackerActions {
    api = stackApi
    reducer = "stacks"
    actionTypes = {
        fetched: STACKS_FETCHED,
        removed: STACK_REMOVED,
        created: STACK_CREATED,
        updated: STACK_UPDATED,
    }
    selectStack = id => {
        return dispatch => {
            dispatch({ type: STACK_SELECTED, id: id })
        }
    }
}

let SA = new StackActions()
SA.actions = { ...SA.actions, selectStack: SA.selectStack }
export const stackActions = SA.actions

// STATE
const initialState = {
    stacks: [],
    entities: {},
    fetching: [],
    selected: null,
}

// REDUCERS
export function stackReducer(state = initialState, action) {
    var stacks, stack, fetching
    switch (action.type) {
        case STACKS_FETCHED:
            return {
                ...state,
                stacks: unique([...state.stacks, ...action.payload.map(stack => stack._sid)]),
                entities: { ...state.entities, ...byID(action.payload) },
            }
        case STACK_CREATED:
            stacks = [...state.stacks, [action.payload._sid]]
            return {
                ...state,
                stacks,
                entities: { ...state.entities, [action.payload._sid]: action.payload },
            }
        case STACK_UPDATED:
            stack = { ...state.entities[action.id], ...action.payload }
            return {
                ...state,
                entities: { ...state.entities, [stack._sid]: stack },
            }
        case STACK_REMOVED:
            stacks = state.stacks.map(stacks => without(stacks, action.id))
            return {
                ...state,
                stacks,
            }
        case STACK_SELECTED:
            localStorage.setItem("stack_id", action.id)
            return {
                ...state,
                selected: action.id,
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }
        default:
            return state
    }
}

// SELECTORS
export const getStackEntities = state => state.stacks.entities
export const getStacks = state => {
    if (typeof state.stacks.stacks.map !== "function") debugger
    return state.stacks.stacks.map(stackId => state.stacks.entities[stackId])
}
export const getSelectedStack = state =>
    state.stacks.entities[localStorage.getItem("stack_id")] || {}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/stackApi.js